module.exports = __webpack_public_path__ + "2ecf71e7cc8ce6ae580e0cba0771600a.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/unimpressed-10.png
// module id = 2244
// module chunks = 0